module.exports = __webpack_public_path__ + "static/media/speech_20.73ed4734.svg";